export const TRIGGER_EMPLOYER_NOTIFICATION_ALERT = "EMPLOYER_NOTIFICATION_ALERT.TRIGGER";
export const HIDE_EMPLOYER_NOTIFICATION_ALERT = "EMPLOYER_NOTIFICATION_ALERT.HIDE";